import Analytics from "../../../analytics";
import Config from "../../../config";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";
import {saveQuote} from "../../../api/server-api";
import {renderErrorPopup} from "../../../api/api-popups";
import {showQuoteSavedNotification} from "../../ui/successNotification";

export const handleBackToDashboard = () => {
  if (window.salesForceLoaded || typeof(sr) != 'undefined') {
    Analytics.sendClickEvent('see-job-in-salesforce');
    let payload = {QCJobId: document.kvConfig.jobId};
    console.log('attempting to view job in SalesForce', payload);
    let eventPayload = {name: 'quoteCountertops.viewJobInSF', payload }
    try {
      window.Sfdc.canvas.client.publish(sr.client, eventPayload);
    } catch(e) {
      console.log('unable to send via salesforce viewpage');
    }
    if (typeof(sfdcMessage) !== 'undefined') {
      sfdcMessage.postMessage(eventPayload);
    }
  } else {
    Analytics.sendClickEvent('back-to-dashboard');
    Config.parent && Config.parent.exitEditQuote && Config.parent.exitEditQuote();
    loaderDisable(); // in case it is not an iframe
    showQuoteSavedNotification();
  }
};

export const handleSaveAndBackToDashboard = () => {

  if (!document.kvConfig.jobId) {
    renderErrorPopup("The Quote can not be saved, no JobId is assigned yet");
    return false
  }

  loaderEnable("loader.savingQuoteText");
  saveQuote({submit: true})
    .then(handleBackToDashboard)
    .catch(handleBackToDashboard)
};
